import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { UiBlocker } from '@bingads-webui-fluent-component/ui-blocker';
import { matchStepState, useWizardService, STEP_STATES } from '@bingads-webui-react/wizard-core';

interface BusyBlockerProps {
  children: React.ReactNode;
  loadingText?: string;
}
export const BusyBlocker: React.FC<BusyBlockerProps> = ({ children, loadingText, ...restProps }) => {
  const i18n = useContext(I18nContext) as any;

  const { state } = useWizardService();
  const isLoading = matchStepState(state, STEP_STATES.FETCHING) || matchStepState(state, STEP_STATES.LOADING);
  const isSaving = matchStepState(state, STEP_STATES.SAVING);
  const defaultLoadingText = isLoading ? i18n.getString(_TL_('Loading...')) : i18n.getString(_TL_('Saving...'));

  return (
    <UiBlocker blocking={isLoading || isSaving} loadingText={loadingText || defaultLoadingText} {...restProps}>
      {children}
    </UiBlocker>
  );
};
BusyBlocker.defaultProps = {
  loadingText: '',
};

interface SaveBlockerProps {
  children: React.ReactNode;
  loadingText?: string;
}
export const SaveBlocker: React.FC<SaveBlockerProps> = ({ children, loadingText, ...restProps }) => {
  const i18n = useContext(I18nContext) as any;

  const { state } = useWizardService();
  const isSaving = matchStepState(state, STEP_STATES.SAVING);

  return (
    <UiBlocker blocking={isSaving} loadingText={loadingText || i18n.getString(_TL_('Saving...'))} {...restProps}>
      {children}
    </UiBlocker>
  );
};
SaveBlocker.defaultProps = {
  loadingText: '',
};

interface LoadingBlockerProps {
  children: React.ReactNode;
  loadingText?: string;
}
export const LoadBlocker: React.FC<LoadingBlockerProps> = ({ children, loadingText, ...restProps }) => {
  const i18n = useContext(I18nContext) as any;

  const { state } = useWizardService();
  const isLoading = matchStepState(state, STEP_STATES.FETCHING) || matchStepState(state, STEP_STATES.LOADING);

  return (
    <UiBlocker blocking={isLoading} loadingText={loadingText || i18n.getString(_TL_('Loading...'))} {...restProps}>
      {children}
    </UiBlocker>
  );
};
LoadBlocker.defaultProps = {
  loadingText: '',
};
